import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { EStorageType } from "../data-types/storage.enum";
import { CompanyService } from "./company.service";
import { CoworkingService } from "./coworking.service";

@Injectable({
  providedIn: "root",
})
export class LocalStorageService {
  static instance: LocalStorageService = new LocalStorageService();

  constructor() {
    return (LocalStorageService.instance =
      LocalStorageService.instance || this);
  }

  get(key) {
    return localStorage.getItem(key);
  }
  set(key, value) {
    // if(this.get(EStorageType.ActiveCoworking)){
    if (key === EStorageType.ActiveCompany) {
      CompanyService.instance.newCompanySelected.next(value);
    }
    if (key === EStorageType.ActiveCoworking) {
      CoworkingService.instance.newCoworkingSelected.next(value);
    }
    // }
    return localStorage.setItem(key, value);
  }

  delete(key) {
    return localStorage.removeItem(key);
  }
  clear() {
    this.delete(EStorageType.Token);
    this.delete(EStorageType.PostalCode);
    this.delete(EStorageType.RefresToken);
    this.delete(EStorageType.Role);
    this.delete(EStorageType.Coworking);
    this.delete(EStorageType.ActiveCoworking);
    this.delete(EStorageType.Company);
    this.delete(EStorageType.ActiveCompany);
    this.delete(EStorageType.Coworker);
  }
}
